//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Object.js";
import "../no/DebugSession.js";
let d=[[],[[["field","filename"],"EvaluateFieldFromFile",{R_:{newTable:"Fields.FieldTable"}},2,0],[["fieldTable","numNumPoints"],"SampleTable",{R_:{newTable:"Fields.FieldTable"}},2,0]],[]];
SPLM.FieldsDebugSession = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.FieldsDebugSession";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;